import React, { FC } from "react";
import ContentSection from "shared/components/Drawer/components/ContentSection";
import { useGameDetails } from "../../context";
import DetailsItem from "./components/DetailsItem";
import { StyledDetailsContainer } from "./styled";

const General: FC = () => {
  const { gameDetails: game } = useGameDetails();

  if (!game) {
    return null;
  }

  return (
    <ContentSection title="DETAILS">
      <StyledDetailsContainer>
        <DetailsItem title="Product Name:" value={game?.productName || "-"} />
        <DetailsItem
          title="Game name:"
          value={game?.name || game.displayName || "-"}
        />
        <DetailsItem title="Game Identifier:" value={game?.id} />
        <DetailsItem
          title="External Identifier:"
          value={game?.externalId || "-"}
        />
        <DetailsItem
          title="Product Supplier ID:"
          value={game?.productSupplierId || "-"}
        />
        <DetailsItem title="Product ID:" value={game?.productId || "-"} />
        <DetailsItem
          title="Progressive Jackpots:"
          value={game?.progressiveJackpots.join(",") || "-"}
        />
        <DetailsItem
          title="Demo Play:"
          value={Boolean(game?.demoPlayRestricted) ? "Inactive" : "Active"}
        />
        <DetailsItem
          title="Real Play:"
          value={Boolean(game?.realPlayRestricted) ? "Inactive" : "Active"}
        />
        <DetailsItem
          title="Maintenance Mode:"
          value={Boolean(game?.maintenanceModeEnabled) ? "True" : "False"}
        />
      </StyledDetailsContainer>
    </ContentSection>
  );
};

export default General;
